const getWorkOrderManagement = (state) => {
  return state?.workOrderManagement;
};

export { getWorkOrderManagement };
